'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CatalogDate = require('./CatalogDate.scss');

var _CatalogDate2 = _interopRequireDefault(_CatalogDate);

require('moment-duration-format');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COUNTDOWN_CUTOFF_HOURS = 24;

var CatalogDate = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(CatalogDate, _PureComponent);

    function CatalogDate() {
        (0, _classCallCheck3.default)(this, CatalogDate);
        return (0, _possibleConstructorReturn3.default)(this, (CatalogDate.__proto__ || (0, _getPrototypeOf2.default)(CatalogDate)).apply(this, arguments));
    }

    (0, _createClass3.default)(CatalogDate, [{
        key: 'isWithin24Hours',
        value: function isWithin24Hours(now, upcoming) {
            var totalHoursUntil = upcoming.diff(now, 'hours', true);

            if (totalHoursUntil >= 0 && totalHoursUntil < COUNTDOWN_CUTOFF_HOURS) {
                return true;
            }
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                date = _props.date,
                forceCountdown = _props.forceCountdown;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CatalogDate2.default['card-date']]).join(' ').trim();

            var now = (0, _momentTimezone2.default)();
            var upcoming = _momentTimezone2.default.unix(date).tz(_momentTimezone2.default.tz.guess());

            var displayDate = (0, _jsx3.default)('span', {
                className: _CatalogDate2.default.date
            }, void 0, upcoming.format('MMM D, YYYY'));
            if (forceCountdown || this.isWithin24Hours(now, upcoming)) {
                var duration = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
                displayDate = (0, _jsx3.default)('span', {
                    className: _CatalogDate2.default.countdown
                }, void 0, (0, _jsx3.default)(_caterwaulComponents.Icon, {
                    name: 'clock-o',
                    className: _CatalogDate2.default.clock
                }), duration.format('d[d] h[h] m[m]'));
            }

            return (0, _jsx3.default)('span', {
                className: classes
            }, void 0, displayDate);
        }
    }]);
    return CatalogDate;
}(_react.PureComponent), _class.defaultProps = {
    className: '',
    date: 0,
    forceCountdown: false
}, _temp);
exports.default = CatalogDate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogDate/CatalogDate.js
// module id = vCo/
// module chunks = 46